module.exports = __webpack_public_path__ + "img/caja_kit.ba55575b.png";